import React from 'react';
import { FieldValues, RegisterOptions, useController } from 'react-hook-form';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface InputFieldProps extends HookFormProps {
  width?: number;
  height?: number;
  placeholder?: string;
  maxLength?: number;
  rules?:
    | Omit<RegisterOptions<FieldValues, string>, 'setValueAs' | 'disabled' | 'valueAsNumber' | 'valueAsDate'>
    | undefined;
}

const InputField = ({ prefixName, width, height, placeholder, maxLength = 30, rules }: InputFieldProps) => {
  const { field, fieldState } = useController({ name: `${prefixName}`, rules });

  return (
    <div className={cx('inputArea')}>
      <input
        {...field}
        className={cx('input', { error: fieldState.invalid })}
        type="text"
        maxLength={maxLength}
        placeholder={placeholder}
        style={{
          width,
          height,
        }}
      />
      {fieldState.invalid && <div className={cx('errorMessage')}>{fieldState.error?.message}</div>}
    </div>
  );
};

export default InputField;
